
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gQAHqj5Tw0BLL_pHxOx_450CKirHSnd8cBecq7Ii_oZdgYMeta } from "/codebuild/output/src523500131/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexEK4h2HTUmjGdCG6QCD_AH9Hjaa4QBTVEldC9X5_45uzbYMeta } from "/codebuild/output/src523500131/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchyV4oQgZSMviyfcrg0bz5SOC1Q2V26CpH9hPc8NL0noQMeta } from "/codebuild/output/src523500131/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index8iazCQguI_2GEReUGkNklSdOTyP7R28CeGL80lLduPoMeta } from "/codebuild/output/src523500131/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93woLg8LSV43EBrD5djTcthkxMUb0zo_QcxL1JMe9L0ekMeta } from "/codebuild/output/src523500131/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexzs9Oo_mXipuUTDChjDXapkLvOcBrvmkK2W4xSnLernEMeta } from "/codebuild/output/src523500131/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93d1N5bFhL8fXe5C_45D3PN3GQ_45_45VtAICZID6CvD8RcrGacMeta } from "/codebuild/output/src523500131/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexrJd8VLsyPbSPfw6YkqB8_45iCch_45zYJPBcVCnMeeIzSh0Meta } from "/codebuild/output/src523500131/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93pF3Zz_IKfcztb0zYiwTtFIeuO1jpYuzrhzModnq7baMMeta } from "/codebuild/output/src523500131/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexpvuwkVunLDjzupYzSCcXxbsOlP9dJMOXyTb_45kWgYZCAMeta } from "/codebuild/output/src523500131/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexTILlzGf9VK55SgZlrUrt57qqH72Iyffbf4p_E18vIp4Meta } from "/codebuild/output/src523500131/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src523500131/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src523500131/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src523500131/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src523500131/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src523500131/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexzs9Oo_mXipuUTDChjDXapkLvOcBrvmkK2W4xSnLernEMeta || {},
    component: () => import("/codebuild/output/src523500131/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src523500131/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexrJd8VLsyPbSPfw6YkqB8_45iCch_45zYJPBcVCnMeeIzSh0Meta || {},
    component: () => import("/codebuild/output/src523500131/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src523500131/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexpvuwkVunLDjzupYzSCcXxbsOlP9dJMOXyTb_45kWgYZCAMeta || {},
    component: () => import("/codebuild/output/src523500131/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexTILlzGf9VK55SgZlrUrt57qqH72Iyffbf4p_E18vIp4Meta || {},
    component: () => import("/codebuild/output/src523500131/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]